import { useEffect } from 'react';

import { useAppSelector } from '@/shared/hooks';

import {
  selectIsProcessing,
  selectIsRecording,
  selectIsUploading,
  selectRecordingTranscriptorV2,
} from '../model/transcriptorSlice.selectors';

export const useRecordingBeforeUnload = () => {
  const isRecording = useAppSelector(selectIsRecording);
  const isProcessing = useAppSelector(selectIsProcessing);
  const isUploading = useAppSelector(selectIsUploading);
  const isTranscriptorV2 = useAppSelector(selectRecordingTranscriptorV2);
  // A v2 dictation sends its last live fill while it uploads, which can take
  // minutes: a closed page loses what that fill has not sent yet.
  const isFinishing = isTranscriptorV2 && isUploading;

  useEffect(() => {
    if (!isRecording && !isProcessing && !isFinishing) {
      return;
    }

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload, {
      capture: true,
    });

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload, {
        capture: true,
      });
    };
  }, [isRecording, isProcessing, isFinishing]);
};
